/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'hydrate.js'.
 */
export default () => import('./index')